import { resetReducerKeys } from '../../constants/app-constants';
import { C2bAuctionAEService, C2bListingService, C2bOmsService } from '../../services';
import types from './types';

const auctionRequest = () => (
    {
        type: types.AUCTION_REQUEST,
    }
);
const auctionResponse = () => (
    {
        type: types.AUCTION_RESPONSE,
    }
);
const setAuctions = (data) => (
    {
        type: types.SET_AUCTIONS,
        data
    }
);
const setSearchFlag = (data) => (
    {
        type: types.SET_SEARCH_FLAG,
        data
    }
);
const setAuctionTypeFlag = (data) => (
    {
        type: types.SET_AUCTION_TYPE,
        data
    }
);
const resetAuctions = () => ({
    type: resetReducerKeys.RESET_AUCTIONS
});

const getAuctionsList = (payload, isPaginate, needLoader = true) => (dispatch, getState) => {
    const { auctions } = getState();
    if (needLoader) dispatch(auctionRequest());
    return new Promise((resolve, reject) => {
        C2bListingService.fetchAuctionList(payload)
            .then(response => {
                let data = [];
                if (isPaginate) {
                    data = { ...response?.data, results: [...auctions?.results, ...response?.data?.results] };
                } else data = response?.data;
                dispatch(setAuctions(data));
                resolve(data);
            }).catch(error => {
                dispatch(setAuctions({ results: [], total: 0 }));
                reject(error);
            })
            .finally(() => dispatch(auctionResponse()));
    });
};
const getMyCars = (payload) => () => {
    return new Promise((resolve, reject) => {
        C2bListingService.fetchMyCars(payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

const fetchBidDetails = (auctionId) => () => {
    return new Promise((resolve, reject) => {
        C2bAuctionAEService.fetchBidDetails(auctionId)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const submitPlaceBid = (payload) => () => {
    return new Promise((resolve, reject) => {
        C2bAuctionAEService.placeBid(payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};
const requestCallback = (dealerId) => {
    return new Promise((resolve, reject) => {
        C2bOmsService.requestCallback(dealerId)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    getAuctionsList,
    getMyCars,
    fetchBidDetails,
    submitPlaceBid,
    setSearchFlag,
    setAuctionTypeFlag,
    resetAuctions,
    requestCallback
};
